if (!customElements.get('bt-catalog-updates')) {
  customElements.define('bt-catalog-updates', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bt-updates-track]');
      this.prev = this.querySelector('[data-bt-updates-prev]');
      this.next = this.querySelector('[data-bt-updates-next]');
      if (!this.track || !this.prev || !this.next) return;
      this.move = (direction) => this.track.scrollBy({ left: direction * Math.max(this.track.clientWidth * .82, 260), behavior: 'smooth' });
      this.prev.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.update = () => {
        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      new ResizeObserver(this.update).observe(this.track);
      this.update();
    }
  });
}
